var portfolioEvaluationChart = {
	"3m": "3M",
	"1y": "1J",
	"1stTrade": "Sinds 1e Handelsdag",
	rangeDescription: "Bereik {start} tot {end}"
};
var nl = {
	portfolioEvaluationChart: portfolioEvaluationChart
};

export { nl as default, portfolioEvaluationChart };
